import React, { useState } from 'react';

import { useIntl } from 'react-intl';

import { useSelector } from 'react-redux';

import { useLocation } from 'react-router-dom';

import { Divider, Dropdown, Menu } from 'antd';

import {
  SubnodeOutlined,
  DownloadOutlined,
  EditOutlined,
} from '@ant-design/icons';

import { RibbonButton, DownloadFormItem } from 'common/components';
import DownloadNifFormSection from 'pages/home/ribbon/components/sections/product/DownloadNifFormSection';
import AssignCategoryToProduct from 'pages/home/ribbon/components/sections/product/AssignCategoryToProduct';

import ProductClone from './ProductClone';
import SyndicationSectionHistory from './SyndicationHistorySection';
import MappingInitSyncSection from './MappingInitSyncSection';
import ProductSheets from './ProductSheets';
import BulkEditProduct from '../product/BulkEditProduct';

import HistoryEntity from 'pages/home/ribbon/form-manange/components/form-history-grid/HistoryEntity';

import GDSNPublication from 'common/components/product-publication-setup/GDSNPublication';
import PostToWalmart from 'common/components/product-publication-setup/PostToWalmart';
import CreateProductViaFormModal from 'common/components/product-add/CreateProductViaFormModal';
import { OverlayActionMenuList } from 'pages/home/ribbon/components/sections/product/components/overlay-action-dropdown';
import WithdrawPublicationButton from '../product/WithdrawPublicationButton';

import AssignCategoryToProductModal from '../product/AssignCategoryToProductModal';
import CopyProductPropertiesModal from '../../modal/bulk-edit-product/CopyProductPropertiesModal';
import ImportProductBulkEditModal from '../../modal/bulk-edit-product/ImportProductBulkEditModal';
import ExportProductPropertiesModal from '../../modal/bulk-edit-product/ExportProductPropertiesModal';
import PublicationSetupModal from 'common/components/product-publication-setup/PublicationSetupModal';
import PublicationValidationView from 'pages/branded-products/components/publication-validation-view/PublicationValidationView';
import BulkProductOverlay from '../../sections/product/components/bulk-product-overlay-dropdown/BulkProductOverlay';

import { CanShow } from 'common/components/wrapper/show-condition';

import { useCheckPermissionAnd } from 'hooks/useCheckPermissions';
import { useIsMutating } from '@tanstack/react-query';

import {
  EXPORT_PRODUCT_PROPERTIES,
  useExportProductOverlayProperty,
  useExportProductProperty,
  EXPORT_PRODUCT_OVERLAY_PROPERTIES,
  useGetLatestProductFullViewInBulkEdit,
} from '../../modal/bulk-edit-product/hook';

import {
  useCheckIsSuperAdmin,
  useCheckAllowEditProducts,
  useCheckMemberSupplier,
  useCheckIsSuperMember,
  useGlobalModal,
} from 'hooks';
import { useCheckPermissions } from 'hooks/useCheckPermissions';
import { useCheckDisableWithdrawPublicationModal } from 'hooks';
import { useCheckDisabledBulkProductOverlay } from '../../sections/product/components/bulk-product-overlay-dropdown/useCheckDisabledBulkProductOverlay';

import {
  ABILITY_ACTION,
  ABILITY_SUBJECT,
  PERMISSION_VIEW_NEW_ITEM_FORMS,
} from 'static/Permission';

import { Can } from 'context/Can';

import messages from 'i18n/messages/home';
import messagesProduct from 'i18n/messages/product';

import * as ssoProductSelectors from 'pages/sso-product/controllers/selectors';

import IXOneSection from '../../sections/product/IXOneSection';
import useCheckIXOneCapture from 'hooks/useCheckIXOneCapture';
import MakeProductActive from '../../sections/product/MakeProductActive';
import { checkDeployEnv } from 'utils/checkDeployEnv';
import { SECURE_CONFIG } from 'utils/SecureRoute';

import { IMPORT_PRODUCT_FOR_BULK_EDITING } from 'services/product/endpoints';
import { UPLOAD_OVERLAYS_BULK_TEMPLATE } from 'services/overlay/endpoints';

import { PRODUCT_VIEW } from 'static/Constants';

const sectionAfterProductSlashIdRegex = /[^\/product\/(0-9)][a-z]*/g;

const { SubMenu } = Menu;

const ProductFullAction = ({ productFull, productId }) => {
  const location = useLocation();

  const intl = useIntl();

  const [requestParams, setRequestParams] = useState(null);

  const { checkModalVisible, MODAL_NAMES, openModal, closeModal } =
    useGlobalModal();

  const { getLatestFullViewData, getLatestFullViewDataOverlay } =
    useGetLatestProductFullViewInBulkEdit({ productId });

  const exportProductPropertyMutation = useExportProductProperty();

  const exportProductOverlayPropertyMutation =
    useExportProductOverlayProperty();

  const isExportProductPropertyLoading = useIsMutating({
    mutationKey: EXPORT_PRODUCT_PROPERTIES,
  });

  const isExportProductOverlayPropertyLoading = useIsMutating({
    mutationKey: EXPORT_PRODUCT_OVERLAY_PROPERTIES,
  });

  const isAssignCategoryModalOpen = checkModalVisible(
    MODAL_NAMES.ASSIGN_CATEGORY_TO_PRODUCT
  );
  const isAddEditModalOpen = checkModalVisible(
    MODAL_NAMES.ADD_EDIT_PRODUCT_MODAL
  );
  const isCopyProductModalOpen = checkModalVisible(
    MODAL_NAMES.COPY_PRODUCT_MODAL
  );
  const isExportProductPropertyModalOpen = checkModalVisible(
    MODAL_NAMES.EXPORT_PROPERTY_MODAL
  );
  const isExportProductOverlayPropertyModalOpen = checkModalVisible(
    MODAL_NAMES.EXPORT_BULK_PRODUCT_OVERLAY
  );

  const isImportProductPropertyModalOpen = checkModalVisible(
    MODAL_NAMES.IMPORT_PROPERTY_MODAL
  );

  const isImportProductOverlayModalOpen = checkModalVisible(
    MODAL_NAMES.IMPORT_BULK_PRODUCT_OVERLAY
  );

  const isPublicationSetupModalOpen = checkModalVisible(
    MODAL_NAMES.PUBLICATION_SETUP_MODAL
  );

  const isPublicationValidateViewModalOpen = checkModalVisible(
    MODAL_NAMES.PUBLICATION_VALIDATE_VIEW_MODAL
  );

  const isBpSsoProductValidate = useSelector(
    ssoProductSelectors.selectIsBpSsoProductValidate()
  );

  const { checkAllowEditProductFull } = useCheckAllowEditProducts();
  const isValidPermissionAND = useCheckPermissionAnd();

  const activeSectionAfterProductId = location.pathname.match(
    sectionAfterProductSlashIdRegex
  )?.[0];

  const validateOverview = () => {
    const regex = /\/product\/\d+$/;
    const isOverview = regex.test(location.pathname);
    return isOverview ? PRODUCT_VIEW.OVERVIEW : null;
  };

  const getActiveContent = () => {
    const regex = /\/(?:product)\/(.+)(?=\/\d+$)/;

    const results = location?.pathname?.match(regex);

    return results?.length
      ? results[1]
      : isBpSsoProductValidate
      ? PRODUCT_VIEW.OVERVIEW
      : validateOverview();
  };

  const activeContent = getActiveContent();

  const isActiveView = [
    PRODUCT_VIEW.DETAILVIEW,
    PRODUCT_VIEW.OVERVIEW,
    PRODUCT_VIEW.QA_SPEC,
    PRODUCT_VIEW.QA_EVALUATION_FORM,
    PRODUCT_VIEW.VERSIONS,
  ].includes(activeContent);

  const isAllowEditProduct = checkAllowEditProductFull(productFull);

  const allowSeeProductSyndication = isValidPermissionAND([
    SECURE_CONFIG.ACCESS_SYNDICATION.PASS,
    SECURE_CONFIG.ACCESS_GDSN.PASS,
    SECURE_CONFIG.PRODUCT.PASS,
  ]);

  const isSuperAdmin = useCheckIsSuperAdmin();
  const isMemberSupplierUser = useCheckMemberSupplier();
  const isSuperMember = useCheckIsSuperMember();

  const isAllowToDownloadNifForm = useCheckPermissions(
    PERMISSION_VIEW_NEW_ITEM_FORMS
  );

  const isDisableWithdrawPublicationModal =
    useCheckDisableWithdrawPublicationModal(productFull);
  const isProdEnv = checkDeployEnv('production');

  const isDisabledBulkProductOverlay =
    useCheckDisabledBulkProductOverlay(productFull);

  const handleCancel = () => {
    closeModal(MODAL_NAMES.PUBLICATION_SETUP_MODAL);
    setRequestParams([]);
  };

  const handleOk = (values) => {
    setRequestParams(values);
    openModal(MODAL_NAMES.PUBLICATION_VALIDATE_VIEW_MODAL);
  };

  const onExportProductProperty = (exportProperties, allPopulated) => {
    exportProductPropertyMutation.mutate({
      productIds: [productFull?.productId],
      selectedColumns: exportProperties,
      allPopulated,
    });
  };

  const onExportProductOverlayProperty = (exportProperties, allPopulated) => {
    exportProductOverlayPropertyMutation.mutate({
      productIds: [productFull?.productId],
      selectedColumns: exportProperties,
      allPopulated,
    });
  };

  const disabledDropdown =
    !isActiveView &&
    !isSuperAdmin &&
    !isSuperMember &&
    isMemberSupplierUser &&
    !isAllowEditProduct;

  const isShowIXOneCapture = useCheckIXOneCapture();

  const menuOptions = (
    <Menu>
      {/* {isShowIXOneCapture ? (
        <>
          <Menu.Item>
            <IXOneSection
              size='small'
              label='Send to IX-ONE for Capture'
              width='20px'
              isDetailView
            />
          </Menu.Item>
          <Divider style={{ margin: 0 }} />
        </>
      ) : null}

      {!isProdEnv ? (
        <Menu.Item
          key='make-active-product'
          style={{
            backgroundColor: 'inherit',
          }}
        >
          <MakeProductActive isFullView />
        </Menu.Item>
      ) : null} */}

      {isActiveView && (
        <>
          <Menu.Item
            key='edit-product'
            style={{
              backgroundColor: 'inherit',
            }}
          >
            <RibbonButton
              size='small'
              icon={<EditOutlined style={{ height: 26 }} />}
              label={messages.productEdit}
              onClick={() => openModal(MODAL_NAMES.ADD_EDIT_PRODUCT_MODAL)}
              disabled={!isAllowEditProduct}
              className='button-item-dropdown'
            />
          </Menu.Item>

          {/* {!checkDeployEnv('production') && !checkDeployEnv('demo') && (
            <OverlayActionMenuList.ProductOriginFullView
              productId={productId}
              productFull={productFull}
            />
          )}

          {!checkDeployEnv('production') && !checkDeployEnv('demo') && (
            <SubMenu
              key='product-overlay-bulk-action'
              style={{ backgroundColor: 'inherit' }}
              title={
                <RibbonButton
                  className='button-item-dropdown'
                  icon={<EditOutlined />}
                  label={'Bulk Product Overlay'}
                  size={'small'}
                  disabled={isDisabledBulkProductOverlay}
                />
              }
              disabled={isDisabledBulkProductOverlay}
            >
              <BulkProductOverlay />
            </SubMenu>
          )} */}

          <Can I={ABILITY_ACTION.CREATE} a={ABILITY_SUBJECT.PRODUCT}>
            <Menu.Item
              key='clone-product'
              style={{
                backgroundColor: 'inherit',
              }}
            >
              <ProductClone
                isDisabled={!isAllowEditProduct}
                productId={productFull?.productId}
              />
            </Menu.Item>
          </Can>
        </>
      )}

      <CanShow.SharedOnlyMember>
        {/* <Menu.Item
          key='syndication-history'
          style={{
            backgroundColor: 'inherit',
          }}
        >
          <SyndicationSectionHistory
            productFull={productFull}
            disabled={
              productFull?.status !== 'Active' || !allowSeeProductSyndication
            }
          />
        </Menu.Item> */}

        {/* {[PRODUCT_VIEW.SYNDICATION].includes(activeSectionAfterProductId) && (
          <Menu.Item
            key='mapping-sync'
            style={{
              backgroundColor: 'inherit',
            }}
          >
            <MappingInitSyncSection />
          </Menu.Item>
        )} */}

        {/* <Menu.Item
          key='sheets'
          style={{
            backgroundColor: 'inherit',
          }}
        >
          <ProductSheets productId={productFull?.productId} disabled={true} />
        </Menu.Item>
        <Can I={ABILITY_ACTION.MAINTAIN} a={ABILITY_SUBJECT.SYNDICATION}>
          <Menu.Item
            key='publish-gdsn-product'
            style={{
              backgroundColor: 'inherit',
            }}
          >
            <GDSNPublication isFullView productFull={productFull} />
          </Menu.Item>
        </Can> */}

        {/*isSuperAdmin && (
          <Menu.Item
            key='post-to-walmart'
            style={{
              backgroundColor: 'inherit',
            }}
          >
            <PostToWalmart isFullView />
          </Menu.Item>
        )*/}
        {/* 
        <Menu.Item
          key='delete-publication'
          style={{
            backgroundColor: 'inherit',
          }}
        >
          <WithdrawPublicationButton
            products={[{ id: productFull?.productId }]}
            isDisabled={isDisableWithdrawPublicationModal}
          />
        </Menu.Item> */}

        {/* <Menu.Item
          key='download-nif-form'
          style={{
            backgroundColor: 'inherit',
          }}
          disabled={!isAllowToDownloadNifForm}
        >
          <DownloadNifFormSection
            detailItems={[{ id: productFull?.productId }]}
            isAllowToDownloadNifForm={isAllowToDownloadNifForm}
          />
        </Menu.Item> */}

        {/* <Menu.Item
          key='download-splash-form'
          style={{ backgroundColor: 'inherit' }}
        >
          <DownloadFormItem
            selectedEntityIds={[productFull?.productId]}
            entityType='PIM'
          />
        </Menu.Item> */}
        {/* <Menu.Item key='history-entity' style={{ backgroundColor: 'inherit' }}>
          <HistoryEntity
            size='small'
            entityId={productFull?.productId}
            entityType='PIM'
          />
        </Menu.Item> */}
      </CanShow.SharedOnlyMember>

      <SubMenu
        key={'bulk-edit-product'}
        style={{ backgroundColor: 'inherit' }}
        disabled={!isAllowEditProduct}
        title={
          <RibbonButton
            size='small'
            className='button-item-dropdown'
            icon={<DownloadOutlined />}
            disabled={!isAllowEditProduct}
            label={messagesProduct.bulkEditProduct}
          />
        }
      >
        <BulkEditProduct
          disabled={!isAllowEditProduct}
          disabledExport={!isAllowEditProduct}
          selectedProducts={[productFull?.productId]}
          isProductDetail
        />
      </SubMenu>
      {/* <Can I={ABILITY_ACTION.ASSIGN} a={ABILITY_SUBJECT.PRODUCT_CATEGORY}>
        <Menu.Item
          key='assign-category-to-product-detail'
          style={{ backgroundColor: 'inherit' }}
        >
          <AssignCategoryToProduct isProductDetail={true} />
        </Menu.Item>
      </Can> */}
      {/* <Menu.Item
        key='assign-product-to-supplier'
        style={{ backgroundColor: 'inherit' }}
      >
        <AssignProductToSupplier
          isProductDetail={true}
          productData={productFull}
        />
      </Menu.Item> */}
    </Menu>
  );

  return (
    <>
      <Dropdown
        overlay={menuOptions}
        placement='bottomLeft'
        disabled={disabledDropdown}
        arrow
      >
        <RibbonButton
          icon={<SubnodeOutlined />}
          label={messages.productActions}
        />
      </Dropdown>

      {isAddEditModalOpen && (
        <CreateProductViaFormModal isEdit productId={productId} />
      )}
      {isAssignCategoryModalOpen && (
        <AssignCategoryToProductModal
          isProductDetail={true}
          productFull={productFull}
        />
      )}
      {isCopyProductModalOpen && (
        <CopyProductPropertiesModal productId={productId} />
      )}
      {isExportProductPropertyModalOpen && (
        <ExportProductPropertiesModal
          title={intl.formatMessage(messagesProduct.exportProperties)}
          onExport={onExportProductProperty}
          visible={isExportProductPropertyModalOpen}
          loading={isExportProductPropertyLoading}
          closeModal={() => closeModal(MODAL_NAMES.EXPORT_PROPERTY_MODAL)}
        />
      )}
      {isExportProductOverlayPropertyModalOpen && (
        <ExportProductPropertiesModal
          title={intl.formatMessage(
            messagesProduct.exportPropertiesProductOverlay
          )}
          onExport={onExportProductOverlayProperty}
          visible={isExportProductOverlayPropertyModalOpen}
          loading={isExportProductOverlayPropertyLoading}
          closeModal={() => closeModal(MODAL_NAMES.EXPORT_BULK_PRODUCT_OVERLAY)}
        />
      )}
      {isImportProductPropertyModalOpen && (
        <ImportProductBulkEditModal
          title={intl.formatMessage(messagesProduct.importProductBulkEditTitle)}
          apiUrl={IMPORT_PRODUCT_FOR_BULK_EDITING}
          visible={isImportProductPropertyModalOpen}
          closeModal={() => closeModal(MODAL_NAMES.IMPORT_PROPERTY_MODAL)}
          onSuccess={getLatestFullViewData}
        />
      )}
      {isImportProductOverlayModalOpen && (
        <ImportProductBulkEditModal
          title={intl.formatMessage(
            messagesProduct.importProductOverlayBulkEditTitle
          )}
          apiUrl={UPLOAD_OVERLAYS_BULK_TEMPLATE}
          visible={isImportProductOverlayModalOpen}
          closeModal={() => closeModal(MODAL_NAMES.IMPORT_BULK_PRODUCT_OVERLAY)}
          onSuccess={getLatestFullViewDataOverlay}
        />
      )}
      {isPublicationSetupModalOpen && (
        <PublicationSetupModal
          handleCancel={handleCancel}
          handleOk={handleOk}
          isFullView={true}
          productFull={productFull}
        />
      )}

      {isPublicationValidateViewModalOpen && (
        <PublicationValidationView
          requestParams={requestParams}
          isFullView={true}
          productId={productFull?.productId}
        />
      )}
    </>
  );
};

export default ProductFullAction;
